// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"630":"b43e9539","2288":"b43e9539","2529":"b43e9539","3536":"b43e9539","3550":"b43e9539","4586":"b43e9539","4619":"b43e9539","5604":"b43e9539","7588":"b43e9539","7995":"b43e9539"}[chunkId] + ".chunk.css";
};